import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { array } from 'fp-ts';
import { requestReload } from '../../../Table/model/commands/requestReload';

/**
 * Force full reload of table data
 *
 * Used e.g. when filters change and set of visible rows is changed, so we should reset scroll offset etc.
 *
 * @see reloadTableDataInViewport
 */
export const reloadTableData: ApiTableCommandFactory = (cmdContext) => () => {
  cmdContext.updateState((draft) => {
    draft.data = array.empty;
    // Convince LazyRowContainer to refetch data
    draft.rowCount = null;
  });
  cmdContext.getTableModel().dispatch(requestReload);
};
